import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { useAuthStore } from '@/store';
import useWorkStartupMessages from '@/hooks/useWorkStartupMessages';
import WorkProgressUpdate from './WorkProgressUpdate';

export const WORK_STARTUP_PHRASES = ['I’ll get started on your request.'];
const phasePhrases = {
  connecting: 'I’ll help with that on your computer.',
  opening: 'I’ll get started on your request.',
  confirming: 'I’ll get started on your request.',
  resuming: 'I’ll pick up where we left off.',
  service: 'I’ve saved your request. I’m waiting for my computer to be available, then I’ll get started.',
  deployment: 'My computer is getting an update. I’ve saved your request and I’ll start as soon as it’s ready.',
  credits: 'I’ve saved your request. Add some credits and I’ll get started automatically.',
};

// The fast model speaks in the same response row as the Work agent. Keep one
// acknowledgment in place until real activity arrives, without rotating chatter.
export default function WorkStartupCompanion({ phase = 'starting', startedAt = null, prompt = '', conversationId }) {
  const accountId = useAuthStore(state => state.user?.id);
  const generated = useWorkStartupMessages({ prompt, phase, accountId });
  const phrase = generated?.messages?.[0] || phasePhrases[phase] || WORK_STARTUP_PHRASES[0];
  const message = useMemo(() => ({
    id: 'work-startup-response', role: 'assistant', content: phrase,
    timestamp: startedAt, workActions: 'chrome',
  }), [phrase, startedAt]);

  return <View testID="work-startup-companion" style={styles.row}
    accessibilityLiveRegion="polite" accessibilityLabel={phrase}>
    <WorkProgressUpdate conversationId={conversationId} message={message} transient />
  </View>;
}

WorkStartupCompanion.propTypes = {
  phase: PropTypes.string, startedAt: PropTypes.number, prompt: PropTypes.string, conversationId: PropTypes.string,
};

const styles = StyleSheet.create({
  row: { paddingVertical: 12, width: '100%', minWidth: 0 },
});
